import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-header-breadcrumb-link" }
const _hoisted_2 = {
  key: 0,
  class: "p-header-breadcrumb-link__arrow"
}
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.itemKey > 0)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2, ">"))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps(_ctx.tag === 'a' ? { href: _ctx.url } : {}, {
      class: [_ctx.linkItemClassNameBase, _ctx.currentLinkClassName],
      onClick: _ctx.clickDisable
    }), {
      default: _withCtx(() => [
        (_ctx.isLower)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.text), 1))
          : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), { key: 1 }))
      ]),
      _: 1
    }, 16, ["class", "onClick"])), [
      [_directive_touch, void 0, "tap"]
    ])
  ]))
}